

import {Component, Mixins, Prop} from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import {DosyaKapatmaNedenleriCevap} from "@/plugins/uyap-plugin/uyap/DosyaKapatmaNedenleri";

@Component({
  components: {}
})

export default class DosyaKapatmaNedenleriPicker extends Mixins(SimpleInputMixin) {
  @Prop() rules!: Array<(v: any) => boolean | string>;

  items: DosyaKapatmaNedenleriCevap = [];

  onKapatmaNedeniChange() {
    // Once kapanmaId'yi yay, sonra adi: dinleyen form her iki alani da dolu gorsun.
    this.input();
    this.$emit('kapanmaAdi', (this.items.find(item => item.value == this.localValue))?.name ?? "");
  }

  created() {
    this.load();
  }

  async load() {
    this.items = (await this.$uyap.DosyaKapatmaNedenleri().run({dosyaTurKod: 35}));
  }
}
